<template>
  <div class="confirm-email">
    <div class="center">
      <h1>{{ $t("confirmEmailPage.title") }}</h1>
      <p>{{ $t("confirmEmailPage.description") }}</p>
      <text-field :label="$t('confirmEmailPage.passwordLabel')" v-model="password" type="password" />
      <div class="attention">{{ $t("confirmEmailPage.passwordRequirement") }}</div>

      <button @click="confirmEmail" :disabled="password.length < 7" class="enrollment-button">
        {{ $t("confirmEmailPage.submitButton") }}
      </button>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import { showNotifyDialog } from "@/lib/dialog";
import { API, Auth } from "aws-amplify";
import { validate as uuidValidate } from "uuid";
import { NolaApiInitializer } from "@/initializer";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField },
  props: {
    id: String,
  },
  data() {
    return {
      password: "",
      errorMessage: "",
    };
  },
  created() {
    const { id } = this;
    if (!uuidValidate(id)) {
      this.errorMessage = this.$t("confirmEmailPage.validation.invalidUrl") as string;
    }
  },
  methods: {
    async confirmEmail() {
      const { id, password } = this;
      if (!password) return;

      try {
        NolaApiInitializer.init();

        await API.post("Rest", "/mail/confirmverification", {
          body: {
            id,
            password,
          },
        });

        this.errorMessage = "";
        await showNotifyDialog({ content: this.$t("confirmEmailPage.successMessage") as string });

        const result = await Auth.signOut();
        if (!result) {
          localStorage.clear();
        }

        window.location.href = "/auth/signin";
      } catch (err: any) {
        if (err.response.status === 400) {
          this.errorMessage = err.response.data.message;
        } else {
          this.errorMessage = `${this.$t("confirmEmailPage.validation.genericError")} ${JSON.stringify(err)}`;
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
h1 {
  font-size: var(--font-size-md);
  color: var(--color-text-normal);
}
p {
  font-size: var(--font-size-sm);
  color: var(--color-text-normal);
}
.confirm-email {
  position: relative;
  width: 100%;
  height: 100vh;
  color: var(--color-text-on-fixed-bg);
  background-image: url("~@/assets/img/static/top-background.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center {
  margin: 15px auto;
  padding: 30px 15px;
  width: 30%;
  min-width: 300px;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
  text-align: center;
  border-radius: var(--radius-md);

  @include mq(sp) {
    margin: 50px auto;
    padding: 25px 0;
    width: 90%;
    min-width: none;
  }
}

.message {
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
  margin: $margin-s 0;
  padding: 0px 15px;
}

.error-message {
  color: var(--color-warning);
  font-weight: var(--font-weight-bold);
  margin: $margin-s 0;
  padding: 0px 15px;
}

.enrollment-button {
  margin-top: 15px;
  padding: 12px 50px;
  border-radius: var(--radius-rounded);
  background-color: var(--color-primary);
  font-size: var(--font-size-sm);
  color: var(--color-text-on-fixed-bg);

  &:disabled {
    background-color: var(--color-surface-muted);
    color: var(--color-inactive);
  }
}

.attention {
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
}
</style>
